import React from 'react';
import { Reminders } from './Reminders';
import { Payments } from './Payments';

export const RemindersAndPaymentsSection = () => (
  <div className='flex items-center gap-[24px] py-[24px] px-[24px]'>
    <Reminders />
    <Payments />
  </div>
);
